// Both file-upload flows in the old app (Survey reports, Manuals) send the
// file as a base64 string inside a normal JSON body, not multipart form data
// — confirmed by reading UploadSurveyReportModal.js and AddManual.js
// directly. Shared here since both screens need the same conversion.
export const convertFileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });
